export type PassengerDocumentType = 'PASSPORT' | 'DNI' | 'CE' | 'RUC';

export interface PassengerDocumentSource {
  residesInPeru?: boolean | null;
  documentType?: string | null;
  documentNumber?: string | number | null;
  passportNumber?: string | number | null;
  dateOfPass?: string | null;
  doe?: string | null;
}

export interface ResolvedPassengerDocument {
  residesInPeru: boolean;
  documentType: PassengerDocumentType | null;
  documentNumber: string | null;
  passportNumber: string | null;
  passportExpiration: string | null;
}

const DOCUMENT_TYPES = new Set<PassengerDocumentType>([
  'PASSPORT',
  'DNI',
  'CE',
  'RUC'
]);

function toTrimmedString(
  value: string | number | null | undefined
): string | null {
  if (value == null) return null;
  const normalized = String(value).trim();
  return normalized || null;
}

function normalizeDocumentType(
  value: string | null | undefined
): PassengerDocumentType | null {
  const normalized = value?.trim().toUpperCase();
  return normalized && DOCUMENT_TYPES.has(normalized as PassengerDocumentType)
    ? (normalized as PassengerDocumentType)
    : null;
}

export function resolvePassengerDocument(
  passenger: PassengerDocumentSource | null | undefined
): ResolvedPassengerDocument {
  const passportNumber = toTrimmedString(passenger?.passportNumber);
  const explicitDocumentType = normalizeDocumentType(passenger?.documentType);
  const documentType =
    explicitDocumentType ?? (passportNumber ? 'PASSPORT' : null);
  const isPassport = documentType === 'PASSPORT';
  const explicitDocumentNumber = toTrimmedString(passenger?.documentNumber);

  return {
    residesInPeru: passenger?.residesInPeru ?? false,
    documentType,
    documentNumber: isPassport
      ? (explicitDocumentNumber ?? passportNumber)
      : explicitDocumentNumber,
    passportNumber: isPassport
      ? (passportNumber ?? explicitDocumentNumber)
      : null,
    passportExpiration: isPassport
      ? (passenger?.dateOfPass ?? passenger?.doe ?? null)
      : null
  };
}
